const groupWealthPageSecurityFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const itemGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`item-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `item-${index}-title`)) {
      break;
    }

    itemGroups.push({ index, fields: groupFields });
  }

  return { introFields, itemGroups };
};

export default groupWealthPageSecurityFields;
